document.addEventListener('DOMContentLoaded',function(){
  var root=document.getElementById('se-sidebar');
  var overlay=document.querySelector('.se-sidebar-overlay');
  var triggers=document.querySelectorAll('.se-trigger-mobile');
  var closeBtn=document.querySelector('.se-sidebar-close');
  if(!root||!overlay)return;

  function openSidebar(){
    root.classList.add('is-open');
    overlay.hidden=false;
    requestAnimationFrame(function(){overlay.classList.add('is-visible')});
    document.body.classList.add('se-body-lock');
    root.setAttribute('aria-hidden','false');
  }
  function closeSidebar(){
    root.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('se-body-lock');
    root.setAttribute('aria-hidden','true');
    setTimeout(function(){overlay.hidden=true},300);
  }

  function hasSelectedTags(contentElement) {
    return contentElement.querySelector('input:checked') !== null;
  }

  triggers.forEach(function(t){
    if(t.tagName==='BUTTON'&&t.type!=='button')t.type='button';
    t.addEventListener('click',function(e){e.preventDefault();openSidebar()});
  });
  window.seOpenSidebar = function(e) {
    if (e) e.preventDefault();
    openSidebar();
  }
  
  if(closeBtn){closeBtn.addEventListener('click',function(e){e.preventDefault();closeSidebar()})}
  overlay.addEventListener('click',function(e){e.preventDefault();closeSidebar()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('is-open'))closeSidebar()});

  function contentForHeading(h){
    var wrap=h.closest('.sidebar-block__toggle');
    if(!wrap)return;
    return wrap.nextElementSibling.closest('.sidebar-block__content');
  }

  function setIcon(h,open){
    var btn=h.querySelector('.sidebar-block__toggle-icon');
    if(!btn)return;
    btn.classList.toggle('is-active',open); 
  }

  function collapseAll(){
    root.querySelectorAll('.sidebar-block__content').forEach(function(el){
      var open = hasSelectedTags(el);

      el.classList.toggle('is-open', open);
      el.style.removeProperty('display');

      var previousSibling = el.previousElementSibling;
      if (previousSibling) {
          var headingElement = previousSibling.querySelector('.sidebar-block__heading');
          if (headingElement) {
              setIcon(headingElement, open);
          }
      }
    });
  }

  collapseAll();

  document.addEventListener('click',function(e){
    var heading=e.target.closest('#se-sidebar .sidebar-block__heading');
    if(!heading)return;
    if(e.cancelable)e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation)e.stopImmediatePropagation();

    var interactiveElement = e.target.closest('a,button,input,label,select,textarea');
    var isIconToggle = e.target.closest('.sidebar-block__toggle-icon');

    if(interactiveElement && !isIconToggle) return;

    var content=contentForHeading(heading);
    if(!content)return;

    var willOpen=!content.classList.contains('is-open');

    content.classList.toggle('is-open',willOpen);
    setIcon(heading,willOpen);

    root.querySelectorAll('.sidebar-block__content').forEach(function(el){
        if(el !== content) {
            var open = hasSelectedTags(el);
            
            if (open) {
                el.classList.add('is-open');
            } else {
                el.classList.remove('is-open');
            }
            
            var previousSibling = el.previousElementSibling;
            if (previousSibling) {
                var otherHeading = previousSibling.querySelector('.sidebar-block__heading');
                if (otherHeading) {
                    setIcon(otherHeading, open);
                }
            }
        }
        el.style.removeProperty('display'); 
    });
  },true);

  root.addEventListener('change',function(e){
    collapseAll(); 
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function updateGridForSection(sectionEl) {
    if (!sectionEl) return;

    var sidebar = sectionEl.querySelector('.sidebar-section');
    var collectionMatrix = sectionEl.querySelector('.collection-matrix');

    if (!sidebar || !collectionMatrix) return;

    var cards = collectionMatrix.querySelectorAll('.column.one-fourth, .column.one-third');

    if (sidebar.classList.contains('se-sidebar-open')) {
      collectionMatrix.classList.add('se-grid-3');
      cards.forEach(function (card) {
        card.classList.remove('one-fourth');
        card.classList.add('one-third');
      });
    } else {
      collectionMatrix.classList.remove('se-grid-3');
      cards.forEach(function (card) {
        card.classList.remove('one-third');
        card.classList.add('one-fourth');
      });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.se-trigger-desktop');
    if (!trigger) return;

    if (window.innerWidth < 768) return;

    var sectionEl = trigger.closest('section');
    if (!sectionEl) return;

    var sidebar = sectionEl.querySelector('.sidebar-section');
    if (!sidebar) return;

    sidebar.classList.toggle('se-sidebar-open');
    updateGridForSection(sectionEl);
  });

  var observer = new MutationObserver(function () {
    var sections = document.querySelectorAll('section');
    sections.forEach(function (sectionEl) {
      var sidebar = sectionEl.querySelector('.sidebar-section');
      if (!sidebar) return;
      if (!sidebar.classList.contains('se-sidebar-open')) return;
      updateGridForSection(sectionEl);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
